'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.usermanual.edit', [])
  .controller('UsermanualEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/usermanual/edit/index.js